<template>
  <b-modal
    v-model="show"
    title="Sesión Expirada"
    modal-class="modal-danger"
    gradient="danger"
    hide-footer
  >
    <p>Token no presente. Serás redirigido al login.</p>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
